export const downloadFile = (file: Blob, name: string) => {
  const anchor = document.createElement('a')
  const url = URL.createObjectURL(file)

  anchor.href = url
  anchor.download = name

  document.body.appendChild(anchor)
  anchor.click()
  document.body.removeChild(anchor)

  return URL.revokeObjectURL(url)
}

const toDataURL = async (url: string) => {
  try {
    const response = await fetch(url)
    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`)
    }

    const blob = await response.blob()
    return URL.createObjectURL(blob)
  } catch (error) {
    if (error instanceof Error) {
      throw new Error(`Failed to fetch resource: ${error.message}`)
    }
    throw new Error('Unknown error occurred while fetching resource')
  }
}

export const downloadImage = async (url: string, fileName: string) => {
  const a = document.createElement('a')
  const objectUrl = await toDataURL(url)
  a.href = objectUrl
  a.download = fileName
  document.body.appendChild(a)
  a.click()
  document.body.removeChild(a)
  URL.revokeObjectURL(objectUrl)
}
